import Vue from "vue"
import VueRouter from "vue-router"

import Container from "@/views/Container"

import routesDev from "./modules/_dev.js"
import routesAuth from "./modules/auth.js"
import routesDashboard from "./modules/dashboard.js"
import routesCustomers from "./modules/sales/customers.js"
import routesProducts from "./modules/products.js"
import routesExtimates from "./modules/sales/estimates.js"
import routesInvoices from "./modules/sales/invoices.js"

import routesSettings from "./modules/settings.js"
import routesMybizes from "./modules/mybizes.js"
import routesTaxes from "./modules/taxes.js"
import routesAccounting from "./modules/accounting.js"

import routesVendors from "./modules/purchase/vendors.js"
import routesBills from "./modules/purchase/bills.js"
import routesReceipts from "./modules/purchase/receipts.js"

import routesReports from "./modules/reports.js"
import routesCommon from "./modules/common.js"

Vue.use(VueRouter)

const routes = [
  // ...routesDev,
  ...routesAuth,
  ...routesDashboard,
  ...routesCustomers,
  ...routesProducts,
  ...routesExtimates,
  ...routesInvoices,
  ...routesMybizes,
  ...routesTaxes,
  ...routesSettings,
  ...routesVendors,
  ...routesBills,
  ...routesReceipts,
  ...routesAccounting,
  ...routesReports,
  ...routesCommon
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  // component: Container,
  routes
  // routes: [
  //     {
  //         path: "/:lang",
  //         children: routes
  //     }
  // ]
})

export default router
